import geoAPI from "../../../api/geoAPI";
import { SCHEDULE_DAYS, urlContexts } from "../../../constants";

export const getSchedules = async (tenantid: string) => {
  const { data } = await geoAPI.get(
    `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/schedules`,
    {
      headers: {
        tenant: tenantid
      }
    }
  );  
  return data;
};

export const createSchedules = async (body: any, tenantid: string) => {
  const language = localStorage.getItem('LANGUAGE') || "";
   const { data } = await geoAPI.post(
    `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/schedules`,{
      scheduleTypeId: body.scheduleTypeId,
      day: language === 'es' ? SCHEDULE_DAYS[body.day] : body.day.toUpperCase(),
      startTime: body.startTime,
      endTime: body.endTime,
      statusId: body.statusId,
    },
    {
      headers: {
        tenant: tenantid
      }
    }
  );
  return data;
};

export const updateSchedules = async (body: any, tenantid: string) => {
  const language = localStorage.getItem('LANGUAGE') || "";
  const { data } = await geoAPI.put(
    `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/schedules/${body.id}`,{
      scheduleTypeId: body.scheduleTypeId,
      day: language === 'es' ? SCHEDULE_DAYS[body.day] : body.day.toUpperCase(),
      startTime: body.startTime,
      endTime: body.endTime,
      statusId: body.statusId
    },
    {
      headers: {
        tenant: tenantid
      }
    }
  );
  return data;
};

export const deleteSchedules = async (id: any, tenantid: string) => {
  const { data } = await geoAPI.delete(
    `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/schedules/${id}`,
    {
      headers: {
        tenant: tenantid
      }
    }
  );
  return data;
};

export const getSchedulesTypes = async (tenantid: string) => {
  const { data } = await geoAPI.get(
    `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/scheduleTypes`,
    {
      headers: {
        tenant: tenantid
      }
    }
  );
  return data;
};
